import { styled, IconButton, MenuItem, Typography } from "@mui/material";
import { dumontColors } from "../../../colors";

export const MenuButton = styled(IconButton)({
  width: 24,
  height: 24,
  backgroundColor: "rgba(0, 0, 0, 0.02)",
  border: "1px solid rgba(0, 0, 0, 0.04)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const StyledMenuItem = styled(MenuItem)<{ isDelete?: boolean }>(({ isDelete }) => ({
  height: 39.5,
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "0 0 0 16px",
  fontSize: 13,
  fontWeight: 400,
  color: isDelete ? "#D4183D" : dumontColors.text,
  fontFamily: "Manrope",
  "&:hover": {
    backgroundColor: dumontColors.backgroundHover,
  },
}));

export const MenuItemText = styled(Typography)<{ isDelete?: boolean }>(({ isDelete }) => ({
  fontSize: 13,
  fontWeight: 400,
  color: isDelete ? "#D4183D" : dumontColors.text,
  fontFamily: "Manrope",
}));

export const TooltipContent = {
  backgroundColor: dumontColors.gray600,
  color: dumontColors.white,
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 400,
  fontFamily: "Manrope",
  letterSpacing: "0.033em",
};

export const TooltipArrow = {
  color: dumontColors.gray600,
};

export const MenuPaperProps = {
  sx: {
    width: 200,
    backgroundColor: dumontColors.white,
    border: `1px solid ${dumontColors.border}`,
    borderRadius: "8px",
    boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.1)",
    padding: "1px",
  },
};
